'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./build/tinper-bee.js');
} else {
  module.exports = require('./build/tinper-bee.js');
}



//////////////////
// WEBPACK FOOTER
// ./~/tinper-bee/environment.js
// module id = 275
// module chunks = 0